// extracted by mini-css-extract-plugin
export default {"checkMarkIcon":"styles_checkMarkIcon__7dScz","accountType":"styles_accountType__-xk9y","stepLabel":"styles_stepLabel__QecKo"};